/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
export var iterator = /*@__PURE__*/ getSymbolIterator();
export var $$iterator = iterator;
//# sourceMappingURL=iterator.js.map
